<template>
	<div>
		<!-- 档案列表 -->
		<Popup
			v-model="docList_display"
			title="查看健康档案"
			:confirmBtnDisplay="false"
		>
			<div v-loading="docList_loading" style="padding: 15px;">
				<!-- 表格 -->
				<div class="base_table" style="margin-top: 20px;">
					<el-table
						:data="docList_list"
						style="width: 100%"
					>
						<el-table-column
							prop="formatTime"
							label="时间"
						>
						</el-table-column>
						<el-table-column
							label="操作"
							width="300"
						>
							<template slot-scope="scope">
								<el-button
									@click="handleViewClick(scope.row)"
								>查看</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- 表格 end -->
				
				<!-- 页码 -->
				<div class="clear_both" style="margin-top: 20px;">
					<div class="base_pager" style="float: right;">
						<el-pagination 
							layout="total, prev, pager, next, jumper" 
							next-text="下一页" 
							:total="docList_total"
							:current-page="docList_page"
							@current-change="handleDocListPageChange"
						>
						</el-pagination>
					</div>
				</div>
				<!-- 页码 end-->
			</div>
		</Popup>
		<!-- 档案列表 end -->
		
		<!-- 健康档案 -->
		<Popup
			v-model="doc_display"
			title="健康档案"
			:width="950"
			:confirmBtnDisplay="false"
		>
			<div style="min-height: 300px;padding: 15px;">
				<div style="text-align: right;">
					<el-button v-print="printData" type="primary">打印</el-button>
				</div>
				<div style="margin: 20px auto 0;text-align: center;">
					<div id="health_doc" style="display: inline-block;vertical-align: top;"></div>
				</div>
				<!-- <div class="clear_both">
					<p style="float: left;min-height: 24px;line-height: 24px">检查日期：{{ doc_selected.formatTime }}</p>
				</div>
				<div class="base_doc" style="margin-top: 20px;">
					<table border="0" cellpadding="0" cellspacing="0">
						<tr class="b_tt">
							<td colspan="6">一、基本信息</td>
						</tr>
						<tr>
							<td width="16.66%">姓名</td>
							<td width="16.66%">{{ doc_info.basicInforVo.name }}</td>
							<td width="16.66%">性别</td>
							<td width="16.66%">{{ doc_info.basicInforVo.sex == 0 ? '男' : '' }}{{ doc_info.basicInforVo.sex == 1 ? '女' : '' }}</td>
							<td width="16.66%">年龄</td>
							<td>{{ doc_info.basicInforVo.age }}</td>
						</tr>
						<tr>
							<td>联系方式</td>
							<td>{{ doc_info.basicInforVo.phone }}</td>
							<td>地址/学校</td>
							<td colspan="3">{{ doc_info.basicInforVo.address }}</td>
						</tr>
						<tr>
							<td>主诉/症状/需求</td>
							<td colspan="5">{{ doc_info.basicInforVo.symptom }}</td>
						</tr>
						<tr>
							<td>职业或日常生活习惯</td>
							<td colspan="5">{{ doc_info.basicInforVo.career }}</td>
						</tr>
						<tr>
							<td>既往诊断/治疗/训练史</td>
							<td colspan="5">{{ doc_info.basicInforVo.treatmentHistory }}</td>
						</tr>
						<tr>
							<td>家族史</td>
							<td colspan="5">{{ doc_info.basicInforVo.heredity }}</td>
						</tr>
					</table>
				</div>
				
				<div class="base_doc" style="margin-top: 20px;">
					<table border="0" cellpadding="0" cellspacing="0">
						<tr class="b_tt">
							<td colspan="6">二、检查项目</td>
						</tr>
						<tr>
							<td></td>
							<td colspan="4">检查结果</td>
							<td>正常值</td>
						</tr>
						<tr>
							<td width="16.66%">裸眼视力</td>
							<td width="16.66%">OD</td>
							<td width="16.66%">{{ doc_info.checkProjectVo.urightNeva || '/' }}</td>
							<td width="16.66%">OS</td>
							<td width="16.66%">{{ doc_info.checkProjectVo.uleftNeva || '/' }}</td>
							<td>/</td>
						</tr>
						<tr>
							<td>矫正视力</td>
							<td>OD</td>
							<td>{{ doc_info.checkProjectVo.urightCva || '/' }}</td>
							<td>OS</td>
							<td>{{ doc_info.checkProjectVo.uleftCva || '/' }}</td>
							<td>
								<p>3~5岁>0.5</p>
								<p>6岁>0.7</p>
								<p>7岁≥1.0</p>
							</td>
						</tr>
						<tr>
							<td>瞳距(mm)</td>
							<td colspan="4">{{ doc_info.checkProjectVo.pd || '/' }}</td>
							<td>/</td>
						</tr>
						<tr>
							<td>Worth-4-dot检查</td>
							<td colspan="4">{{ doc_info.checkProjectVo.w4dot || '/' }}</td>
							<td>4个</td>
						</tr>
						<tr>
							<td>立体视检查</td>
							<td colspan="4">{{ doc_info.checkProjectVo.stereopsis || '/' }}</td>
							<td>有 /≤60″</td>
						</tr>
						<tr>
							<td>戴镜 NPC</td>
							<td colspan="4">{{ doc_info.checkProjectVo.npc || '/' }}</td>
							<td>3~7cm</td>
						</tr>
						<tr>
							<td>遮盖/交替遮盖</td>
							<td colspan="4">{{ doc_info.checkProjectVo.overspread == 0 ? '遮盖左眼' : '' }}{{ doc_info.checkProjectVo.overspread == 1 ? '遮盖右眼' : '' }}{{ doc_info.checkProjectVo.overspread == 2 ? '不遮盖' : '' }}{{ parseInt(doc_info.checkProjectVo.overspread) == NaN ? '/' : '' }}</td>
							<td>未发生移动</td>
						</tr>
						<tr>
							<td>远距水平眼位</td>
							<td colspan="4">{{ doc_info.checkProjectVo.farPos || '/' }}</td>
							<td>+1 ~ -3 ∆</td>
						</tr>
						<tr>
							<td>近距水平眼位</td>
							<td colspan="4">{{ doc_info.checkProjectVo.nearPos || '/' }}</td>
							<td>0 ~ -6 ∆</td>
						</tr>
						<tr>
							<td>梯度法AC/A</td>
							<td colspan="4">{{ doc_info.checkProjectVo.aca || '/' }}</td>
							<td>3~5 ∆/D</td>
						</tr>
						<tr>
							<td>PRA</td>
							<td colspan="4">{{ doc_info.checkProjectVo.pra || '/' }}</td>
							<td>-1.75~-3.00 D</td>
						</tr>
						<tr>
							<td>NRA</td>
							<td colspan="4">{{ doc_info.checkProjectVo.nra || '/' }}</td>
							<td>+1.75~+2.25 D</td>
						</tr>
						<tr>
							<td rowspan="2">调节灵敏度</td>
							<td rowspan="1">OD</td>
							<td rowspan="1">{{ doc_info.checkProjectVo.accomOD || '/' }}</td>
							<td rowspan="1">OS</td>
							<td rowspan="1">{{ doc_info.checkProjectVo.accomOS || '/' }}</td>
							<td rowspan="1">12cpm</td>
						</tr>
						<tr>
							<td rowspan="1">OU</td>
							<td rowspan="1" colspan="3">{{ doc_info.checkProjectVo.accomOU || '/' }}</td>
							<td rowspan="1">8cpm</td>
						</tr>
						<tr>
							<td>光栅锐度</td>
							<td colspan="4">{{ raster || '/' }}</td>
							<td>≥4.9</td>
						</tr>
						<tr>
							<td>截止频率</td>
							<td colspan="4">{{ cut_off || '/' }}</td>
							<td>≥4.9</td>
						</tr>
						<tr>
							<td>一阶运动</td>
							<td colspan="4">{{ first_motion || '/' }}</td>
							<td>≥4.9</td>
						</tr>
						<tr>
							<td>二阶运动</td>
							<td colspan="4">{{ second_motion || '/' }}</td>
							<td>≥4.9</td>
						</tr>
						<tr>
							<td>二阶空间对比敏感度曲线</td>
							<td colspan="4">{{ curve || '/' }}</td>
							<td>≥4.9</td>
						</tr>
					</table>
				</div>
				
				<div class="base_doc" style="margin-top: 20px;">
					<table border="0" cellpadding="0" cellspacing="0">
						<tr class="b_tt">
							<td>三、诊断建议</td>
						</tr>
						<tr>
							<td v-html="doc_info.adviceVo.advice" style="text-align: left;"></td>
						</tr>
					</table>
				</div>
				
				<div class="base_doc" style="margin-top: 20px;">
					<table border="0" cellpadding="0" cellspacing="0">
						<tr class="b_tt">
							<td colspan="3">四、治疗方案</td>
						</tr>
						<tr>
							<td width="33.33%">配镜方案</td>
							<td colspan="2">{{ doc_info.treatmentProjectVo.glassPlan || '/' }}</td>
						</tr>
						<tr>
							<td>遮盖方案</td>
							<td colspan="2">{{ doc_info.treatmentProjectVo.overspreadPlan || '/' }}</td>
						</tr>
						<tr>
							<td>视觉营养保健方案</td>
							<td colspan="2">{{ doc_info.treatmentProjectVo.foodPlan || '/' }}</td>
						</tr>
						<tr>
							<td rowspan="3">视觉训练方案</td>
							<td rowspan="1" width="33.33%">疗程(周)</td>
							<td rowspan="1">{{ doc_info.treatmentProjectVo.treatmentCourse }}</td>
						<tr>
							<td rowspan="1">视知觉训练频率(天/周)</td>
							<td rowspan="1">{{ doc_info.treatmentProjectVo.softwarePeriod }}</td>
						</tr>
						<tr>
							<td rowspan="1">训练室训练频率(天/周)</td>
							<td rowspan="1">{{ doc_info.treatmentProjectVo.packagepPeriod }}</td>
						</tr>
					</table>
				</div>
				
				<div v-if="doc_info.treatmentProjectVo.ucenterDayPlanVo.oneWeekPlan" class="base_doc" style="margin-top: 20px;">
					<table border="0" cellpadding="0" cellspacing="0">
						<tr class="b_tt">
							<td colspan="5" style="text-align: center;">训练室训练方案</td>
						</tr>
						<tr class="b_tt">
							<td colspan="5" style="text-align: center;">第1周</td>
						</tr>
						<tr v-for="(wItem, wIndex) in oneWeekPlan" :key="wIndex">
							<td width="20%">第{{ Math.ceil(wIndex + 1) }}次训练</td>
							<td v-for="(iItem, iIndex) in wItem" :key="iIndex" width="20%">{{ iItem }}</td>
						</tr>
					</table>
				</div>
				
				<div v-if="doc_info.treatmentProjectVo.ucenterDayPlanVo.twoWeekPlan" class="base_doc" style="margin-top: 20px;">
					<table border="0" cellpadding="0" cellspacing="0">
						<tr class="b_tt">
							<td colspan="5" style="text-align: center;">第2周</td>
						</tr>
						<tr v-for="(wItem, wIndex) in twoWeekPlan" :key="wIndex">
							<td width="20%">第{{ Math.ceil(wIndex + 1) }}次训练</td>
							<td v-for="(iItem, iIndex) in wItem" :key="iIndex" width="20%">{{ iItem }}</td>
						</tr>
					</table>
				</div>
				
				<div v-if="doc_info.treatmentProjectVo.ucenterDayPlanVo.threeWeekPlan" class="base_doc" style="margin-top: 20px;">
					<table border="0" cellpadding="0" cellspacing="0">
						<tr class="b_tt">
							<td colspan="5" style="text-align: center;">第3周</td>
						</tr>
						<tr v-for="(wItem, wIndex) in threeWeekPlan" :key="wIndex">
							<td width="20%">第{{ Math.ceil(wIndex + 1) }}次训练</td>
							<td v-for="(iItem, iIndex) in wItem" :key="iIndex" width="20%">{{ iItem }}</td>
						</tr>
					</table>
				</div>
				
				<div v-if="doc_info.treatmentProjectVo.ucenterDayPlanVo.fourWeekPlan" class="base_doc" style="margin-top: 20px;">
					<table border="0" cellpadding="0" cellspacing="0">
						<tr class="b_tt">
							<td colspan="5" style="text-align: center;">第4周</td>
						</tr>
						<tr v-for="(wItem, wIndex) in fourWeekPlan" :key="wIndex">
							<td width="20%">第{{ Math.ceil(wIndex + 1) }}次训练</td>
							<td v-for="(iItem, iIndex) in wItem" :key="iIndex" width="20%">{{ iItem }}</td>
						</tr>
					</table>
				</div> -->
			</div>
		</Popup>
		<!-- 健康档案 end -->
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js';
	import BaseMethods from '../../../../../assets/js/base.js';
	import MyPrint from '../../../../../assets/js/print.js';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			uid: {
				type: String,
				required: true
			}
		},
		mounted () {
			this.display && (this.docList_display = true);
		},
		data () {
			return {
				printData: {
					id: "health_doc",
					popTitle: '健康档案'
				},
				
				docList_display: false,
				docList_loading: false,
				docList_page: 1,
				docList_total: 0,
				docList_list: [],
				
				doc_display: false,
				doc_selected: {},
				doc_info: null,
				raster: '',
				cut_off: '',
				curve: '',
				first_motion: '',
				second_motion: '',
				oneWeekPlan: [],
				twoWeekPlan: [],
				threeWeekPlan: [],
				fourWeekPlan: []
			}
		},
		methods: {
			/********************** @列表 ****************************/
			// 获取档案列表
			getDocs () {
				const that = this;
				that.docList_loading = true;
				var requestData = {
					limit: 10,
					pageNum: that.docList_page,
					userId: that.uid
				};
				Api.findUserDocs(requestData).then((res) => {
					that.docList_loading = false;
					if (res.data.success) {
						that.docList_total = res.data.data.totalItems;
						that.docList_list = [];
						res.data.data.data.forEach((v) => {
							var _v = v;
							_v.formatTime = BaseMethods.formatTime(_v.ucreateTs, 'yy-mm-dd hh:mm:ss');
							that.docList_list.push(_v);
						});
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.docList_display = false;
					that.$message.error(e.message);
				});
			},
			// 切换页码
			handleDocListPageChange (page) {
				if (this.docList_page != page) {
					this.docList_page = page;
					this.getDocs();
				}
			},
			
			/********************** @档案 ****************************/
			// 点击查看
			handleViewClick (data) {
				this.doc_selected = data;
				this.getDoc();
			},
			// 请求健康档案
			getDoc () {
				const that = this;
				that.docList_loading = true;
				var wrequestData = {
					uId: that.doc_selected.uid,
					userId: that.doc_selected.uuserId
				};
				Api.findUserDoc(wrequestData).then((res) => {
					that.docList_loading = false;
					if (res.data.success) {
						that.doc_info = res.data.data;
						that.getDetectorData();
						that.getWeekPlan();
						that.docList_display = false;
						that.doc_display = true;
						that.$nextTick(() => {
							that.doc_info && that.intPrintContent();
						});
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.docList_loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取检测仪数据
			getDetectorData () {
				var today = new Date().getFullYear()
							+ '-'
							+ (new Date().getMonth() + 1
							> 10 
							? new Date().getMonth() + 1
							: '0' + (new Date().getMonth() + 1))
							+ '-'
							+ (new Date().getDate()
							> 10 
							? new Date().getDate()
							: '0' + new Date().getDate());
				for (var i = 0;i < this.doc_info.trainInfoList.length;i++) {
					var item = this.doc_info.trainInfoList[i],
						train_date= item.ucreateTs
									? item.ucreateTs.split('T')[0]
									: '';
					if (item.utaskId == 1 && today == train_date) {
						this.raster = item.uthresholdLevel;
					} else if (item.utaskId == 2 && train_date == today) {
						this.cut_off = item.uthresholdLevel;
					} else if (item.utaskId == 4 && train_date == today) {
						this.curve =item.uthresholdLevel;
					} else if (item.utaskId == 7 && train_date == today) {
						this.first_motion = item.uthresholdLevel;
					} else if (item.utaskId == 8 && train_date == today) {
						this.second_motion = item.uthresholdLevel;
					}
				}
			},
			// 获取训练室训练方案
			getWeekPlan () {
				var oneWeekPlan = this.doc_info.treatmentProjectVo.ucenterDayPlanVo.oneWeekPlan,
					twoWeekPlan = this.doc_info.treatmentProjectVo.ucenterDayPlanVo.twoWeekPlan,
					threeWeekPlan = this.doc_info.treatmentProjectVo.ucenterDayPlanVo.threeWeekPlan,
					fourWeekPlan = this.doc_info.treatmentProjectVo.ucenterDayPlanVo.fourWeekPlan;
				if (oneWeekPlan)
					this.oneWeekPlan = this.getPlanArray(oneWeekPlan);
				if (twoWeekPlan)
					this.twoWeekPlan = this.getPlanArray(twoWeekPlan);
				if (threeWeekPlan)
					this.threeWeekPlan = this.getPlanArray(threeWeekPlan);
				if (fourWeekPlan)
					this.fourWeekPlan = this.getPlanArray(fourWeekPlan);
			},
			// 获取训练计划的二维数组
			getPlanArray (str) {
				var array = [];
				var transition_arr = str.split(',');
				transition_arr.forEach((v, i) => {
					var index = Math.floor(i / 4),
						remainder = i % 4;
					if (remainder == 0) {
						var inner_arr = [];
						inner_arr.push(BaseMethods.mapDocPlanToName(transition_arr[i]));
						array.push(inner_arr);
					} else {
						array[index].push(BaseMethods.mapDocPlanToName(transition_arr[i]));
					}
				});
				return array;
			},
			// 初始化打印内容
			intPrintContent() {
				let myPrint = new MyPrint({
					container: document.getElementById('health_doc'),
					table: {
						tag: 'table',
						className: 'base_doc',
						attrs: [{
							name: 'border',
							value: '0'
						}, {
							name: 'cellpadding',
							value: '0'
						}, {
							name: 'cellspacing',
							value: '0'
						}]
					}
				});
				myPrint.addRow({
					tag: 'div',
					className: 'clear_both',
					htmlStr: `<p style='float: left;min-height: 24px;line-height: 24px'>检查日期：${ this.doc_selected.formatTime }</p>`
				});
				myPrint.addRow({
					tag: 'tr',
					className: 'b_tt',
					htmlStr: `<td colspan='6'>一、基本信息</td>`,
					tableRequired: true
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>姓名</td>
							<td width='16.66%'>${ this.doc_info.basicInforVo.name || '' }</td>
							<td width='16.66%'>性别</td>
							<td width='16.66%'>${ this.doc_info.basicInforVo.sex == 0 ? '男' : '' }${ this.doc_info.basicInforVo.sex == 1 ? '女' : '' }</td>
							<td width='16.66%'>年龄</td>
							<td>${ this.doc_info.basicInforVo.age || '' }</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>联系方式</td>
							<td width='16.66%'>${ this.doc_info.basicInforVo.phone || '' }</td>
							<td width='16.66%'>地址/学校</td>
							<td colspan='3'>${ this.doc_info.basicInforVo.address || '' }</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>主诉/症状/需求</td>
							<td colspan='5'>${ this.doc_info.basicInforVo.symptom || '' }</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>职业或日常生活习惯</td>
							<td colspan='5'>${ this.doc_info.basicInforVo.career || '' }</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>既往诊断/治疗/训练史</td>
							<td colspan='5'>${ this.doc_info.basicInforVo.treatmentHistory || '' }</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>家族史</td>
							<td colspan='5'>${ this.doc_info.basicInforVo.heredity || '' }</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					className: 'b_tt',
					htmlStr: `<td colspan='6'>二、检查项目</td>`,
					tableRequired: true,
					tableRemove: true
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'></td>
							<td colspan='4'>检查结果</td>
							<td width='16.66%'>正常值</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>裸眼视力</td>
							<td width='16.66%'>OD</td>
							<td width='16.66%'>${ this.doc_info.checkProjectVo.urightNeva || '/' }</td>
							<td width='16.66%'>OS</td>
							<td width='16.66%'>${ this.doc_info.checkProjectVo.uleftNeva || '/' }</td>
							<td>/</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>矫正视力</td>
							<td width='16.66%'>OD</td>
							<td width='16.66%'>${ this.doc_info.checkProjectVo.urightCva || '/' }</td>
							<td width='16.66%'>OS</td>
							<td width='16.66%'>${ this.doc_info.checkProjectVo.uleftCva || '/' }</td>
							<td>
								<p>3~5岁>0.5</p>
								<p>6岁>0.7</p>
								<p>7岁≥1.0</p>
							</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>瞳距(mm)</td>
							<td colspan='4'>${ this.doc_info.checkProjectVo.pd || '/' }</td>
							<td width='16.66%'>/</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>Worth-4-dot检查</td>
							<td colspan='4'>${ this.doc_info.checkProjectVo.w4dot || '/' }</td>
							<td width='16.66%'>4个</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>立体视检查</td>
							<td colspan='4'>${ this.doc_info.checkProjectVo.stereopsis || '/' }</td>
							<td width='16.66%'>有 /≤60″</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>戴镜 NPC</td>
							<td colspan='4'>${ this.doc_info.checkProjectVo.npc || '/' }</td>
							<td width='16.66%'>3~7cm</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>遮盖/交替遮盖</td>
							<td colspan='4'>${ this.doc_info.checkProjectVo.overspread == 0 ? '遮盖左眼' : '' }${ this.doc_info.checkProjectVo.overspread == 1 ? '遮盖右眼' : '' }${ this.doc_info.checkProjectVo.overspread == 2 ? '不遮盖' : '' }${ isNaN(parseInt(this.doc_info.checkProjectVo.overspread)) ? '/' : '' }</td>
							<td width='16.66%'>未发生移动</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>远距水平眼位</td>
							<td colspan='4'>${ this.doc_info.checkProjectVo.farPos || '/' }</td>
							<td width='16.66%'>+1 ~ -3 ∆</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>远距水平眼位</td>
							<td colspan='4'>${ this.doc_info.checkProjectVo.farPos || '/' }</td>
							<td width='16.66%'>+1 ~ -3 ∆</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>近距水平眼位</td>
							<td colspan='4'>${ this.doc_info.checkProjectVo.nearPos || '/' }</td>
							<td width='16.66%'>0 ~ -6 ∆</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>梯度法AC/A</td>
							<td colspan='4'>${ this.doc_info.checkProjectVo.aca || '/' }</td>
							<td width='16.66%'>3~5 ∆/D</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>PRA</td>
							<td colspan='4'>${ this.doc_info.checkProjectVo.pra || '/' }</td>
							<td width='16.66%'>-1.75~-3.00 D</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>NRA</td>
							<td colspan='4'>${ this.doc_info.checkProjectVo.nra || '/' }</td>
							<td width='16.66%'>+1.75~+2.25 D</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td rowspan='2'>调节灵敏度</td>
							<td rowspan='1'>OD</td>
							<td rowspan='1'>${ this.doc_info.checkProjectVo.accomOD || '/' }</td>
							<td rowspan='1'>OS</td>
							<td rowspan='1'>${ this.doc_info.checkProjectVo.accomOS || '/' }</td>
							<td rowspan='1'>12cpm</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td rowspan='1'>OU</td>
							<td rowspan='1' colspan='3'>${ this.doc_info.checkProjectVo.accomOU || '/' }</td>
							<td rowspan='1'>8cpm</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>光栅锐度</td>
							<td colspan='4'>${ this.raster || '/' }</td>
							<td width='16.66%'>≥4.9</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>截止频率</td>
							<td colspan='4'>${ this.cut_off || '/' }</td>
							<td width='16.66%'>≥4.9</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>一阶运动</td>
							<td colspan='4'>${ this.first_motion || '/' }</td>
							<td width='16.66%'>≥4.9</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>二阶运动</td>
							<td colspan='4'>${ this.second_motion || '/' }</td>
							<td width='16.66%'>≥4.9</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='16.66%'>二阶空间对比敏感度曲线</td>
							<td colspan='4'>${ this.curve || '/' }</td>
							<td width='16.66%'>≥4.9</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					className: 'b_tt',
					htmlStr: `<td>三、诊断建议</td>`,
					tableRequired: true,
					tableRemove: true
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td style="text-align: left;">${ this.doc_info.adviceVo.advice || '/' }</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					className: 'b_tt',
					htmlStr: `<td colspan='3'>四、治疗方案</td>`,
					tableRequired: true,
					tableRemove: true
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='33.33%'>配镜方案</td>
							<td colspan='2'>${ this.doc_info.treatmentProjectVo.glassPlan || '/' }</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='33.33%'>遮盖方案</td>
							<td colspan='2'>${ this.doc_info.treatmentProjectVo.overspreadPlan || '/' }</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td width='33.33%'>视觉营养保健方案</td>
							<td colspan='2'>${ this.doc_info.treatmentProjectVo.foodPlan || '/' }</td>`
				});
				myPrint.addRow({
					tag: 'tr',
					htmlStr: `<td colspan='3' style='padding: 0;'>
								<table>
									<tr style='border-bottom: none;'>
										<td rowspan='3' width='33.33%'>视觉训练方案</td>
										<td rowspan='1' width='33.33%' style='border-bottom: 1px solid #ccc;'>疗程(周)</td>
										<td rowspan='1' style='border-right: none;border-bottom: 1px solid #ccc;'>${ this.doc_info.treatmentProjectVo.treatmentCourse || '/' }</td>
									</tr>
									<tr style='border-bottom: none;'>
										<td rowspan='1' style='border-bottom: 1px solid #ccc;'>视知觉训练频率(天/周)</td>
										<td rowspan='1' style='border-right: none;border-bottom: 1px solid #ccc;'>${ this.doc_info.treatmentProjectVo.softwarePeriod || '/' }</td>
									</tr>
									<tr style='border-bottom: none;'>
										<td rowspan='1'>训练室训练频率(天/周)</td>
										<td rowspan='1' style='border-right: none;'>${ this.doc_info.treatmentProjectVo.packagepPeriod || '/' }</td>
									</tr>
								</table>
							</td>`
				});
				const that = this;
				if (this.doc_info.treatmentProjectVo.ucenterDayPlanVo.oneWeekPlan) {
					myPrint.addRow({
						tag: 'tr',
						className: 'b_tt',
						htmlStr: `<td colspan='5'>训练室训练方案</td>`,
						tableRemove: true,
						tableRequired: true
					});
					myPrint.addRow({
						tag: 'tr',
						className: 'b_tt',
						htmlStr: `<td colspan='5'>第1周</td>`
					});
					that.oneWeekPlan.forEach((v, i) => {
						let tdStr = `<td width='20%'>第${ Math.ceil(i + 1) }次训练</td>`;
						v.forEach(item => {
							tdStr += `<td width='20%'>${ item }</td>`;
						});
						myPrint.addRow({
							tag: 'tr',
							htmlStr: tdStr
						});
					});
				}
				if (this.doc_info.treatmentProjectVo.ucenterDayPlanVo.twoWeekPlan) {
					myPrint.addRow({
						tag: 'tr',
						className: 'b_tt',
						htmlStr: `<td colspan='5'>第2周</td>`,
						tableRemove: true,
						tableRequired: true
					});
					that.twoWeekPlan.forEach((v, i) => {
						let tdStr = `<td width='20%'>第${ Math.ceil(i + 1) }次训练</td>`;
						v.forEach(item => {
							tdStr += `<td width='20%'>${ item }</td>`;
						});
						myPrint.addRow({
							tag: 'tr',
							htmlStr: tdStr
						});
					});
				}
				if (this.doc_info.treatmentProjectVo.ucenterDayPlanVo.twoWeekPlan) {
					myPrint.addRow({
						tag: 'tr',
						className: 'b_tt',
						htmlStr: `<td colspan='5'>第3周</td>`,
						tableRemove: true,
						tableRequired: true
					});
					that.threeWeekPlan.forEach((v, i) => {
						let tdStr = `<td width='20%'>第${ Math.ceil(i + 1) }次训练</td>`;
						v.forEach(item => {
							tdStr += `<td width='20%'>${ item }</td>`;
						});
						myPrint.addRow({
							tag: 'tr',
							htmlStr: tdStr
						});
					});
				}
				if (this.doc_info.treatmentProjectVo.ucenterDayPlanVo.twoWeekPlan) {
					myPrint.addRow({
						tag: 'tr',
						className: 'b_tt',
						htmlStr: `<td colspan='5'>第4周</td>`,
						tableRemove: true,
						tableRequired: true
					});
					that.fourWeekPlan.forEach((v, i) => {
						let tdStr = `<td width='20%'>第${ Math.ceil(i + 1) }次训练</td>`;
						v.forEach(item => {
							tdStr += `<td width='20%'>${ item }</td>`;
						});
						myPrint.addRow({
							tag: 'tr',
							htmlStr: tdStr
						});
					});
				}
			}
		},
		watch: {
			display (newVal) {
				this.docList_display = newVal;
			},
			docList_display (newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.docList_loading = false;
					this.docList_page = 1;
					this.docList_total = 0;
					this.docList_list = [];
					this.getDocs();
				}
			},
			doc_display(newVal) {
				if (!newVal) {
					this.doc_selected = {};
					this.doc_info = null;
					this.raster = '';
					this.cut_off = '';
					this.curve = '';
					this.first_motion = '';
					this.second_motion = '';
					this.oneWeekPlan = [];
					this.twoWeekPlan = [];
					this.threeWeekPlan = [];
					this.fourWeekPlan = [];
				}
			}
		}
	}
</script>

<style>
</style>
